import { apiClient } from '@/api/client';

const VAPID_PUBLIC_KEY = import.meta.env.VITE_VAPID_PUBLIC_KEY;

/**
 * Register the Service Worker and subscribe to Web Push.
 */
export async function registerPushNotifications() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push Notifications are not supported in this browser');
    return;
  }

  try {
    // 1. Register Service Worker (using the correct file name: sw.js)
    const registration = await navigator.serviceWorker.register('/sw.js');
    console.log('Service Worker registered:', registration.scope);

    // 2. Wait for registration to be active
    if (!registration.active) {
      console.log('Waiting for Service Worker to become active...');
      await new Promise<void>((resolve) => {
        const check = setInterval(() => {
          if (registration.active) {
            clearInterval(check);
            resolve();
          }
        }, 100);
      });
    }

    // 3. Request Subscription
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      if (!VAPID_PUBLIC_KEY || typeof VAPID_PUBLIC_KEY !== 'string') {
        console.warn(
          'VITE_VAPID_PUBLIC_KEY is not set; skipping new push subscription.'
        );
        return;
      }

      console.log('No existing subscription found. Requesting new subscription...');

      const convertedVapidKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);

      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: convertedVapidKey,
      });
      
      console.log('New subscription created!');
    }

    // 4. Send subscription to Backend
    await apiClient.post('/notifications/push-subscription', subscription);
    console.log('Push subscription synced with backend successfully.');

  } catch (error) {
    console.error('Error during Push Notification registration:', error);
  }
}

/**
 * Helper to convert Base64 VAPID key to Uint8Array required by subscribe()
 */
function urlBase64ToUint8Array(base64String: string) {
  if (!base64String) {
    throw new Error('VAPID public key is empty');
  }
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
